import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const TaylorsSeries = () => (
  <QPhototModuleSubtopic
    title="Taylor's series"
    videos={[
      "https://www.youtube.com/embed/xls_5Ly7VA4",
      "https://www.youtube.com/embed/3X_hGDAECF4",
      "https://www.youtube.com/embed/TWjsrREiijg"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_20.png"},
        {image:"/cvla_21.png"},
        {image:"/cvla_22.png"},
        {image:"/cvla_23.png"},
        {image:"/cvla_24.png"},
    ]}
    exampleVideos={[]}
  />
);

export default TaylorsSeries;
